export enum UserCurrencyType {
  None = 0,
  Credit = 1,
  Hammer = 2,
  MatchTicket = 3
}
